import LinkButton from '@/components/atoms/LinkButton';
import Heading from '../atoms/Heading';

type Props = {
  anchor: string;
};

/**
 * マイページ上にご利用機器情報への導線を配置する案内ボックス。
 * 他の契約情報セクションと並べて置くことで、機器配送や回収確認への入口を見失わせない。
 */
const DeliveryInfo = ({ anchor }: Props) => {
  return (
    <div className='m-box-02' id={anchor}>
      <div className='m-box-02__inner'>
        <Heading as='h2' icon='device'>
          ご利用機器情報
        </Heading>
        {/* 配送状況や回収状況の確認は別画面に集約しているため、このセクションでは入口だけを明確に出す。 */}
        <div className='m-button align-center'>
          {/* 契約情報閲覧の流れを切らないよう、トップ内の 1 アクション導線として置く。 */}
          <LinkButton variant='secondary' href='/top/delivery/'>
            ご利用機器情報の確認
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

export default DeliveryInfo;
